import { Selector } from 'redux/modules/types';
import { createSelector } from 'reselect';
import { ActivityBellState } from './types';

const selectState: Selector<ActivityBellState> = ({ activityBell }) =>
  activityBell;

export const selectActivityBell = createSelector(selectState, ({ byId, ids }) =>
  ids.map((id) => byId[id]!).filter((it): it is NonNullable<typeof it> => !!it),
);

export const selectActivityBellPageCount = createSelector(
  selectState,
  (state) => state.pageCount,
);

export const selectActivityBellLoading = createSelector(
  selectState,
  (state) => state.loading,
);
